import { InjectionToken, isDevMode } from "@angular/core";


export const CustomEnvironment = new InjectionToken<Object>('environments');

export let environment = {
  production: false,
  baseUrl: 'http://localhost:4200/',
  auth: {
    authority: 'http://localhost:8080/realms/internal',
    client_id: 'faac',
    redirect_uri: 'http://localhost:4200/auth-callback',
    post_logout_redirect_uri: 'http://localhost:4200',
    response_type: 'id_token token',
    scope: 'openid profile email',
    filterProtocolClaims: true,
    loadUserInfo: true
  },
  api: {
    aux: 'https://test-api.1stm.ac/forms/aux',
    banking: 'https://test-api.1stm.ac/banking',
    calendar: 'https://test-api.1stm.ac/calendar',
    client: 'https://test-api.1stm.ac/client',
    collateral: 'https://test-api.1stm.ac/collateral',
    communications: 'https://test-api.1stm.ac/communications',
    conditions: 'https://test-api.1stm.ac/conditions',
    files: 'https://test-api.1stm.ac/files',
    history: 'https://test-api.1stm.ac/history',
    jobs: 'https://test-api.1stm.ac/jobs',
    justice: 'https://test-api.1stm.ac/justice',
    payment: 'https://test-api.1stm.ac/payment',
    retail: 'https://test-api.1stm.ac/retail',
    types: 'https://test-api.1stm.ac/types',
    vx: 'https://test-api.1stm.ac/vx',
    v8: 'https://test-web.1stm.ac/v8',
    lcaDomain: 'https://test-www.loansau.io',
    apiIbLoans: 'https://test-api-ib.loans.com.au',
    vxCore: 'https://test-api.1stm.ac/vx-core',
    sales: 'https://test-api.1stm.ac/sales',
    wizards: 'https://test-wizard.1stm.ac',
    settlement: 'https://test-api.1stm.ac/settlements',
    tree: 'https://test-api.1stm.ac/tree',
  },
  lcaCcardEmailTemplateId: 'charged-credit-card-loanscomau',
  firstmacCcardEmailTemplateId: 'charged-credit-card-firstmac'
};

/**
 * Merge the environment API variables
 * @param env overriding environment variable
 */
export function setApiOverrides(env) {
  if (env && env.api) {
    environment.api = Object.assign(environment.api, env.api);
  }
}


/**
 * Set environment URLS here
 * If env is passed, APIs are merged
 */
export function setEnvironmentToProd() {
  console.log('Setting APIs to production URLs...');
  environment = {
    production: false,
    baseUrl: 'https://localhost:4200/',
    auth: {
      authority: 'https://keycloak.firstmac.com.au:8443/realms/internal',
      client_id: 'faac',
      redirect_uri: 'https://faac.firstmac.com.au/auth-callback',
      post_logout_redirect_uri: 'https://faac.firstmac.com.au',
      response_type: 'id_token token',
      scope: 'openid profile email',
      filterProtocolClaims: true,
      loadUserInfo: true
    },
    api: {
      aux: 'https://api.firstmac.com.au/forms/aux',
      banking: 'https://api.firstmac.com.au/banking',
      calendar: 'https://api.firstmac.com.au/calendar',
      client: 'https://api.firstmac.com.au/client',
      collateral: 'https://api.firstmac.com.au/collateral',
      communications: 'https://api.firstmac.com.au/communications',
      conditions: 'https://api.firstmac.com.au/conditions',
      files: 'https://api.firstmac.com.au/files',
      history: 'https://api.firstmac.com.au/history',
      jobs: 'https://api.firstmac.com.au/jobs',
      justice: 'https://api.firstmac.com.au/justice',
      payment: 'https://api.firstmac.com.au/payment',
      retail: 'https://api.firstmac.com.au/retail',
      types: 'https://api.firstmac.com.au/types',
      vx: 'https://api.firstmac.com.au/vx',
      v8: 'https://web.firstmac.com.au/v8',
      lcaDomain: 'https://www.loans.com.au',
      apiIbLoans: 'https://api-ib.loans.com.au',
      wizards: 'https://wizard.firstmac.com.au',
      vxCore: 'https://api.firstmac.com.au/vx-core',
      sales: 'https://api.firstmac.com.au/sales',
      settlement: 'https://api.firstmac.com.au/settlements',
      tree: 'https://api.firstmac.com.au/tree',
    },
    lcaCcardEmailTemplateId: 'charged-credit-card-loanscomau',
    firstmacCcardEmailTemplateId: 'charged-credit-card-firstmac'
  }
}
